import { render, staticRenderFns } from "./dim.vue?vue&type=template&id=552483f6&scoped=true&"
import script from "./dim.vue?vue&type=script&lang=ts&"
export * from "./dim.vue?vue&type=script&lang=ts&"
import style0 from "./dim.vue?vue&type=style&index=0&id=552483f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552483f6",
  null
  
)

export default component.exports